module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ordersubmit"
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid g-my-100"
  }, [_c('div', {
    staticClass: "g-bg-img-hero g-bg-pos-top-center g-pos-rel g-z-index-0 g-mt-minus-150",
    staticStyle: {
      "background-image": "url(/static/assets/include/svg/svg-bg4.svg)"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "row center"
  }, [(_vm.orderType == 'special') ? _c('order-special') : (_vm.orderType == 'pending') ? _c('order-pending') : (_vm.orderDetailsLoading && _vm.orderType == 'error') ? _c('page-loader') : _c('order-error', {
    attrs: {
      "Account": _vm.Account,
      "orderDetails": _vm.orderDetails
    },
    on: {
      "clicked": function($event) {
        return _vm.ToggleHelpForm()
      }
    }
  }), _vm._v(" "), (_vm.orderType != 'error') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.Route('OrderTracking')
      }
    }
  }, [_vm._v("Track Order")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.Route('Order')
      }
    }
  }, [_vm._v("Place New Order")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br')]) : _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.EditOrder(_vm.$route.params.code)
      }
    }
  }, [_vm._v("Edit Order")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.Route('Order')
      }
    }
  }, [_vm._v("Place New Order")])])], 1)])])])]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2827b07d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2827b07d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Order/OrderSubmit/OrderSubmit.vue
// module id = 492
// module chunks = 4